var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"searchBox"},[_c('div',{staticClass:"formBox"},[_vm._t("form")],2),_c('div',{staticClass:"btnBox"},[_vm._t("btns")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }